<template>
  <svg version="1.1" id="a" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48.4 28.8" style="enable-background:new 0 0 48.4 28.8;" xml:space="preserve">
  <g>
    <g>
      <g>
        <path class="st0" d="M26.1,9.9c-1,0-1.7-0.1-1.9-0.1c-0.6,0.1-5.4,0.6-7.6-1.5c-1.6-1.5-2.4-2.9-2.4-4.2c0-1,0.5-2,1.4-2.9
                             c1.5-1.4,4-2.3,7.5,0.9c0.5,0.4,0.8,1,1.1,1.7c0.3-0.7,0.7-1.2,1.1-1.7c3.5-3.2,6-2.3,7.5-0.9c0.9,0.9,1.4,1.8,1.4,2.9
                             c0,1.3-0.8,2.7-2.4,4.2C30.4,9.7,27.9,9.9,26.1,9.9z M18.6,1c-0.8,0-1.6,0.3-2.4,1c-0.7,0.7-1.1,1.4-1.1,2.1c0,1,0.7,2.2,2,3.5
                             c1.6,1.5,4.9,1.4,6.3,1.3l-1-0.5C22.4,8.4,19.5,7,18,5.6C17.3,5,17,4.4,17,3.8c0-0.5,0.2-0.8,0.3-0.9l0,0c0,0,1.1-0.9,2.8,0.7
                             c1.5,1.4,3,4.1,3,4.2l0.6,1.1c0.2,0,0.3,0,0.3,0l-0.4-2.9c-0.2-1.4-0.6-2.4-1.3-3C21,1.6,19.8,1,18.6,1z M24.9,8.9
                             c1.4,0.1,4.7,0.2,6.3-1.3c1.4-1.3,2-2.4,2-3.5c0-0.8-0.4-1.4-1.1-2.1c-1.7-1.6-3.7-1.3-6.1,0.9c-0.7,0.6-1.1,1.6-1.3,3l-0.4,2.9
                             c0,0,0.1,0,0.3,0l0.6-1.1c0.1-0.1,1.6-2.8,3-4.2l0,0c1.7-1.6,2.8-0.7,2.8-0.7c0.1,0.1,0.4,0.4,0.3,0.9c0,0.6-0.4,1.2-1.1,1.8
                             C28.9,7,26,8.4,25.9,8.4L24.9,8.9z M28.9,4.3c-0.7,0.6-1.4,1.6-1.9,2.4c0.9-0.5,2-1.2,2.7-1.8c0.7-0.7,0.8-1.1,0.7-1.3
                             C30.2,3.5,29.7,3.6,28.9,4.3L28.9,4.3z M18,3.6c-0.1,0.2,0,0.6,0.7,1.3c0.7,0.6,1.8,1.3,2.7,1.8c-0.5-0.8-1.2-1.8-1.9-2.4
                             C18.7,3.6,18.2,3.5,18,3.6z"/>
      </g>
    </g>
    <g>
      <path class="st1" d="M22.4,2.9C21,1.6,19.8,1,18.6,1c-0.8,0-1.6,0.3-2.4,1c-0.7,0.7-1.1,1.4-1.1,2.1c0,1,0.7,2.2,2,3.5
                           c1.6,1.5,4.9,1.4,6.3,1.3l-1-0.5C22.4,8.4,19.5,7,18,5.6C17.3,5,17,4.4,17,3.8c0-0.5,0.2-0.8,0.3-0.9l0,0c0,0,1.1-0.9,2.8,0.7
                           c1.5,1.4,3,4.1,3,4.2l0.6,1.1c0.2,0,0.3,0,0.3,0l-0.4-2.9C23.5,4.5,23.1,3.5,22.4,2.9z"/>
      <path class="st1" d="M31.1,7.6c1.4-1.3,2-2.4,2-3.5c0-0.8-0.4-1.4-1.1-2.1c-1.7-1.6-3.7-1.3-6.1,0.9c-0.7,0.6-1.1,1.6-1.3,3
                           l-0.4,2.9c0,0,0.1,0,0.3,0l0.6-1.1c0.1-0.1,1.6-2.8,3-4.2c1.7-1.6,2.8-0.7,2.8-0.7c0.1,0.1,0.4,0.4,0.3,0.9c0,0.6-0.4,1.2-1.1,1.8
                           C28.9,7,26,8.4,25.9,8.4l-1,0.5C26.3,9,29.6,9.1,31.1,7.6z"/>
    </g>
    <g>
      <path class="st0" d="M34.4,28.8H14c-0.8,0-1.5-0.7-1.5-1.5V16.8c0-0.8,0.7-1.5,1.5-1.5h20.4c0.8,0,1.5,0.7,1.5,1.5v10.4
                           C35.9,28.1,35.2,28.8,34.4,28.8z M14,16.3c-0.3,0-0.5,0.2-0.5,0.5v10.4c0,0.3,0.2,0.5,0.5,0.5h20.4c0.3,0,0.5-0.2,0.5-0.5V16.8
                           c0-0.3-0.2-0.5-0.5-0.5H14z"/>
    </g>
    <path class="st2" d="M34.4,16.3H14c-0.3,0-0.5,0.2-0.5,0.5v10.4c0,0.3,0.2,0.5,0.5,0.5h20.4c0.3,0,0.5-0.2,0.5-0.5V16.8
                         C34.9,16.5,34.7,16.3,34.4,16.3z"/>
    <g>
      <path class="st0" d="M35.6,16.3H12.7c-0.8,0-1.5-0.7-1.5-1.5v-3c0-0.8,0.7-1.5,1.5-1.5h22.9c0.8,0,1.5,0.7,1.5,1.5v3
                           C37.1,15.6,36.5,16.3,35.6,16.3z M12.7,11.3c-0.3,0-0.5,0.2-0.5,0.5v3c0,0.3,0.2,0.5,0.5,0.5h22.9c0.3,0,0.5-0.2,0.5-0.5v-3
                           c0-0.3-0.2-0.5-0.5-0.5H12.7z"/>
    </g>
    <path class="st2" d="M35.6,11.3H12.7c-0.3,0-0.5,0.2-0.5,0.5v3c0,0.3,0.2,0.5,0.5,0.5h22.9c0.3,0,0.5-0.2,0.5-0.5v-3
                         C36.1,11.6,35.9,11.3,35.6,11.3z"/>
    <g>
      <path class="st0" d="M27.2,16.3h-6v-6h6V16.3z M22.2,15.3h4v-4h-4V15.3z"/>
    </g>
    <rect x="22.2" y="11.3" class="st3" width="4" height="4"/>
    <g>
      <path class="st0" d="M27.2,28.8h-6V15.3h6V28.8z M22.2,27.8h4V16.3h-4V27.8z"/>
    </g>
    <rect x="22.2" y="16.3" class="st3" width="4" height="11.4"/>
    <g>
      <g>
        <path class="st0" d="M47.9,16.3h-4.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h4.5c0.3,0,0.5,0.2,0.5,0.5
                             C48.4,16.1,48.1,16.3,47.9,16.3z"/>
      </g>
      <g>
        <path class="st0" d="M42.6,11.3c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.2-0.7l3.9-2.3c0.2-0.1,0.5-0.1,0.7,0.2
                             C47.1,8.5,47,8.9,46.7,9l-3.9,2.3C42.7,11.3,42.7,11.3,42.6,11.3z"/>
      </g>
      <g>
        <path class="st0" d="M46.5,23.6c-0.1,0-0.2,0-0.2-0.1l-3.9-2.3c-0.2-0.1-0.3-0.4-0.2-0.7s0.4-0.3,0.7-0.2l3.9,2.3
                             c0.2,0.1,0.3,0.4,0.2,0.7C46.8,23.5,46.7,23.6,46.5,23.6z"/>
      </g>
    </g>
    <g>
      <g>
        <path class="st0" d="M5,16.3H0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5H5c0.3,0,0.5,0.2,0.5,0.5
                             C5.5,16.1,5.3,16.3,5,16.3z"/>
      </g>
      <g>
        <path class="st0" d="M1.9,23.6c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.5,0.2-0.7l3.9-2.3c0.2-0.1,0.5-0.1,0.7,0.2
                             c0.1,0.2,0.1,0.5-0.2,0.7l-3.9,2.3C2.1,23.6,2,23.6,1.9,23.6z"/>
      </g>
      <g>
        <path class="st0" d="M5.8,11.3c-0.1,0-0.2,0-0.2-0.1L1.6,9C1.4,8.9,1.3,8.5,1.5,8.3C1.6,8.1,1.9,8,2.1,8.1L6,10.4
                             c0.2,0.1,0.3,0.4,0.2,0.7C6.1,11.2,6,11.3,5.8,11.3z"/>
      </g>
    </g>
  </g>
</svg>
</template>

<script>
export default {

}
</script>

<style scoped>
svg {
  max-width: 49px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

svg .st0 {
  fill:#3D3D3D;
}

svg .st1 {
  fill-rule:evenodd;
  clip-rule:evenodd;
  fill:#FF6666;
}

svg .st2 {
  fill:#3AACE8;
}

svg .st3 {
  fill:#FF6666;
}

body {
  background: #E3E8EA;
  text-align: center;
}

#a {
  animation: a 5s ease-in-out infinite;
}

@keyframes a {
  0% {
    transform: translate(-50%, -50%) rotate(0);
  }
  2.5% {
    transform: translate(-50%, -50%) rotate(5deg) scale(1.1);
  }
  5% {
    transform: translate(-50%, -50%) rotate(0) scale(1.1);
  }
  7.5% {
    transform: translate(-50%, -50%) rotate(5deg) scale(1.1);
  }
  10% {
    transform: translate(-50%, -50%) rotate(0) scale(1);
  }
  100% {
    transform: translate(-50%, -50%) rotate(0);
  }
}
</style>